import {ReactNode} from "react";

/**
 * Marker component that signals to the i18n linter that its children
 * do not need translating (e.g. format strings, technical identifiers,
 * internal-only text).
 */
const NoTranslate = ({children}: {children: ReactNode}) => <>{children}</>;

export default NoTranslate;
